import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  Stack,
} from "@mui/material";
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import SvgIconStyle from "../../components/SvgIconStyle";
import DIOText from "../../components/DIOText";


export default function AttendancePoilcyDialog({ isOpen, closeDialog }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="dg">
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, pt: { xs: 3, sm: 4 } }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          출퇴근 정책
        </Typography>
        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 3 }}>
          <SvgIconStyle src={`/icons/icon-check-mono.svg`} sx={{ width: 24, height: 24, color: "text.disabled" }} />
          <Stack spacing={1}>
            <Typography variant="subtitle1">
              회사와 계약 기간 동안 <DIOText /> 시스템 내 출퇴근 기능으로 업무를 기록해야합니다.
            </Typography>
            <Typography variant="body2">
              업무 시간 내에 출퇴근 기록을 하지 못했다면, 출퇴근 수동 등록을 해주세요.
            </Typography>
            <Typography variant="body2">
              출퇴근 기록과 업무 내역은 <DIOText />와 기업이 검토합니다. 기업의 급여 승인 프로세스에 참고가 되는 자료이니 신경써서 등록해주세요.
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 3 }}>
          <SvgIconStyle src={`/icons/icon-check-mono.svg`} sx={{ width: 24, height: 24, color: "text.disabled" }} />
          <Stack spacing={1}>
            <Typography variant="subtitle1">
              약속한 코어 타임에 근무해야하며, 변경 시 회사에 사전 공유해주세요.
            </Typography>
            <Typography variant="body2">
              코어타임 반복 미준수 시 기업이 업무 불성실로 간주하여 이의 제기 또는 계약 해지의 사유로 삼을 수 있으니 유의하여 주십시오.
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 3 }}>
          <SvgIconStyle src={`/icons/icon-check-mono.svg`} sx={{ width: 24, height: 24, color: "text.disabled" }} />
          <Stack spacing={1}>
            <Typography variant="subtitle1">
              출퇴근 기록과 당일 진행한 업무는 <DIOText />와 회사에 공유됩니다.
            </Typography>
            <Typography variant="body2">
              기록한 내용은 급여 청구서에도 반영되며, 회사가 내용을 확인 후 급여 청구서에 조율을 요청할 수 있습니다. 
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" spacing={1} alignItems="flex-start">
          <SvgIconStyle src={`/icons/icon-check-mono.svg`} sx={{ width: 24, height: 24, color: "text.disabled" }} />
          <Stack spacing={1}>
            <Typography variant="subtitle1">
              출근 시 진행할 업무를 기록해야 출근 기록이 시작되며, 퇴근 시 진행한 업무를 기록해야 퇴근 시간이 기록됩니다. 
            </Typography>
            <Typography variant="body2">
              수동 출퇴근 기록 시, 수동 등록 사유와 해당 출퇴근 시간에 진행한 업무를 기록해야합니다. 
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ mx: { xs: 0, sm: 1 } }}>
        <Button variant="contained" fullWidth={!smUp} size="large" sx={{ px: 3 }} onClick={closeDialog} >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}